import NextSeoModule from '../../../component/next-seo'
import CourseCertificate from '@/component/course-new-details/course-certificate'
import CourseFaq from '@/component/course-new-details/course-faq'
import CourseOverview from '@/component/course-new-details/course-overview'
import CourseSchedule from '@/component/course-new-details/course-schedule'
import CourseSyllabus from '@/component/course-new-details/course-syllabus'
import CourseTabs from '@/component/course-new-details/course-tabs'
import CourseTestimonial from '@/component/course-new-details/course-testimonial'
import GuidenceProcess from '@/component/course-new-details/guidence-process'
import HeroSection from '@/component/course-new-details/hero-section'
import JobSupport from '@/component/course-new-details/job-support'
import KeyHighlights from '@/component/course-new-details/key-highlights'
import PaymentOptions from '@/component/course-new-details/payment-options'
import RelatedCourses from '@/component/course-new-details/related-courses'
import TrainingMode from '@/component/course-new-details/training-mode'
import Layout from '@/component/layout'
import React, { useRef } from 'react'
import axios from "axios";
import Otherlocation from '@/component/coursetemplate/otherlocation/otherlocation/other'

export default function Awstraininginchennai({
    title,
    title1,
    description,
    url,
    url1,
    url2,  
    location, 
    location1,
    Intro,
    Overview,    
    frequently,
    TestiData,
    syllabusData,
    certificate,
    relatedCourse,
    jobSupport,
    insights
  }) {
    const sectionsRef = {
      overViewRef: useRef(null),
      trainingModeRef: useRef(null),
      paymentOptionRef: useRef(null),
      courseSyllabus: useRef(null),
      projectRef: useRef(null),
      courseCertificate: useRef(null),
      schedule: useRef(null),
      testimonialRef: useRef(null),
      guindenceProcessRef: useRef(null),
      jobSupportRef: useRef(null),
      courseFaq: useRef(null),
    };
  
    // If critical data is missing, return fallback UI
    if (!title || !Overview) {
         console.log(Overview)
         console.log(title)
      return <p>No course data found</p>;
    }
    if(title&&Overview){
    return (
      <>

        <NextSeoModule
          title={`${title} - learnsoft.org`}
          description={description}
          url={`kochi/${url}`}
          img={`course/${url2}-training.webp`}
          faq={frequently}
          keyword={`${title1} training in ${location}, ${title1} certification in ${location}, Online ${title1}  Training in ${location}, ${title1} Online Training in ${location}, ${title1} Syllabus, ${title1} course in ${location}, ${title1} classes in ${location}, ${title1} institute in ${location}, Best ${title1} training institute in ${location}, ${title1} training and certification in ${location}, Best ${title1} training in ${location}, ${title1} coaching in ${location}, ${title1} training center in ${location}, ${title1} training provider in ${location}`} 
        />
        <Layout navbarBackgroundColor="#281E1E">
          <HeroSection title={title} language={"English"} Intro={Intro} insights={insights} />
          <KeyHighlights title={title1} location1={location1} location={location}/>
          <CourseTabs refs={sectionsRef} title={title1} location1={location1} />
          <CourseOverview title={title} location1={location1} img={url2} SectionRef={sectionsRef.overViewRef} overview={Overview} />
          <TrainingMode title={title1} location={location} location1={location1} SectionRef={sectionsRef.trainingModeRef} />
          <PaymentOptions title={title1} location={location}/>
          <CourseSyllabus title={title1} location1={location1} syllabusData={syllabusData} SectionRef={sectionsRef.courseSyllabus} />
          <CourseCertificate certificate={certificate} title={title1} location={location} SectionRef={sectionsRef.courseCertificate} />
          <CourseSchedule title={title1}/>
          <CourseTestimonial title={title1} TestiData={TestiData} SectionRef={sectionsRef.testimonialRef} />
          <GuidenceProcess title={title1} />
          <JobSupport jobSupport={jobSupport} title={title1} location1={location1} SectionRef={sectionsRef.jobSupportRef} />
          <CourseFaq title={title1} location1={location1} faq={frequently} SectionRef={sectionsRef.courseFaq} />
          <Otherlocation url={url2} title={title1} pathloc1={"coimbatore"} loc1={'Coimbatore'}
          pathloc2={"noida"} loc2={'Noida'} pathloc3={"delhi"} loc3={'Delhi'} pathloc4={"trivandrum"} loc4={'Trivandrum'}
          pathloc5={"bangalore"} loc5={'Bangalore'}pathloc6={"hyderabad"} loc6={'Hyderabad'} pathloc7={"pune"} loc7={'Pune'}
          pathloc8={"gurgaon"} loc8={'Gurgaon'}pathloc9={"mumbai"} loc9={'Mumbai'}/>        
         <RelatedCourses relatedCourse={relatedCourse} location1={location1} title={title} url1={url1}/>
        </Layout>
      </>
    );
   }
  }
  
   const correctUrlPath = (resolvedUrl, query1) => {
    const pathSegments = resolvedUrl.split("/").filter(Boolean);
    if (pathSegments.length < 2) {
      console.error("Invalid URL structure");
      return null;
    }
    
    const query2 = pathSegments[1];
    const parts = query2.split("-");
    parts[parts.length - 1] = query1;
    pathSegments[pathSegments.length - 1] = parts.join("-");
    return pathSegments.join("/");
  };
  
  export async function getServerSideProps({ query, resolvedUrl }) {
    const { slug } = query;

    const pathSegments = resolvedUrl.split("/").filter(Boolean);
    const query1 = pathSegments[0];
    let data = null;
    let data2 = null;
    let res1 =null;
    let res2=null;
  
    // Correct the URL path
    const correctedPath = correctUrlPath(resolvedUrl, query1);
  
    if (!correctedPath) {
      console.log("hello")
      return { notFound: true };
    }
  
    const lastSegment = slug.split("-").pop();

    if (lastSegment !== query1) {
      // Redirect to corrected URL if necessary
      return {
        redirect: {
          destination: `${process.env.url}/${correctedPath}`,
          permanent: true, // Set to true if this is a permanent redirect (status 308)
        },
      };
    }
  
    // Perform API calls if the slug is valid
    if (slug && slug.includes("-")) {
      try {
        // First API request to fetch course details
         res1 = await axios.get(`${process.env.db_url}/api/coursedetails`, {
          params: { searchquery: slug },
        });

        if (!res1 || res1.status !== 200 || !res1.data) {
      
          return { notFound: true };
        }else{
            data = res1.data; 

            const url2=data[0].url2 || null;

            data=data[0];           
            // Second API request to fetch abstract data
            if (url2!==null) {
              try {
                 res2 = await axios.get(`${process.env.db_url}/api/abstractdata`, {
                    params: { url: url2 },
                });
            } catch (error) {
                console.error('Error response:', error.response?.data);
                console.error('Error message:', error.message);
            }
            
                if (!res2 || res2.status !== 200 || !res2.data) {
                    return { notFound: true };
                }   

                data2 = res2.data;
            
            }else{
              console.log("no data")
            }
        }  
        
      } catch (error) {
        console.error("Error fetching data:", error.message);
        return { notFound: true };
      }
    } else {
      // Return 404 if slug is not valid
      return { notFound: true };
    }

  
    return {
      props: {
        title: data?.title || '',
        title1: data?.title1 || '',
        description: data?.description || '',
        url: data?.url || '',
        url1: data?.url1 || '',
        url2: data?.url2 || '',
        location: data?.location || '',
        location1: data?.location1 || '',
        Intro: data?.intro || '',
        Overview: data2?.overview || '',
        frequently: data2?.frequently || '',
        TestiData: data2?.testidata || '',
        syllabusData: data2?.syllabusdata || '',
        certificate: data2?.certificate || '',
        relatedCourse: data2?.relatedcourse || '',
        jobSupport: data2?.jobsupport || '',
        insights:data2?.insights|| ''
      },
    };
  }
